/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DownloadDocumentsMutation($input: DownloadDocuments_M_simulation_recapInput!) {
    downloadDocuments_M_simulation_recap(input: $input) {
      ok
      error
      
        urls 
        fileType 
        errorDuringUpload 
    }
  }
`;

export default mutation;
